export const SN = 'FEEDBACK'
export const SHOW_FEEDBACK = SN + '/SHOW_FEEDBACK'
